"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconBase = _interopRequireDefault(require("cccisd-icons/dist/IconBase.js"));
var _arrowLeft = _interopRequireDefault(require("cccisd-icons/arrow-left20"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down20"));
var _defaultFilterGroupIcons = _interopRequireDefault(require("../defaultFilterGroupIcons.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var appDefs = window.cccisd.appDefs;

// Simple collapsible component for the FilterSideBar
var Component = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Component, [].concat(args));
    _defineProperty(_this, "state", {
      open: !_this.props.isCollapsed
    });
    _defineProperty(_this, "toggle", function (e) {
      e && e.preventDefault();
      _this.setState(function (prevState) {
        return {
          open: !prevState.open
        };
      });
    });
    _defineProperty(_this, "getIcon", function () {
      var icon = _this.props.icon;
      if (icon && icon !== 'none') {
        var filterGroupIcons = appDefs.resourceCenters.filterGroupIcons || _defaultFilterGroupIcons["default"];
        return filterGroupIcons.find(function (fg) {
          return fg.id === icon;
        });
      }
    });
    _defineProperty(_this, "getFilterBarColor", function () {
      var _this$props = _this.props,
        color = _this$props.color,
        icon = _this$props.icon,
        displayOptions = _this$props.displayOptions;
      if (color && icon && icon !== 'none' && color !== '') {
        return {
          backgroundColor: color
        };
      }
      if (displayOptions.portal && displayOptions.portal.filterCollapseColor) {
        return {
          backgroundColor: displayOptions.portal.filterCollapseColor
        };
      }
    });
    return _this;
  }
  _inherits(Component, _React$Component);
  return _createClass(Component, [{
    key: "render",
    value: function render() {
      var isCollapsible = this.props.collapsible;
      var displayOptions = this.props.displayOptions;
      var icon = this.getIcon();
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        onClick: isCollapsible ? this.toggle : null,
        style: this.getFilterBarColor(),
        className: _style["default"].header + ' ' + (this.state.open ? _style["default"].open : '') + ' ' + (isCollapsible ? _style["default"].collapsible : '')
      }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, displayOptions.resources.showFilterGroupIcons && icon && /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          margin: '0 0.5em',
          color: '#fff'
        }
      }, /*#__PURE__*/_react["default"].createElement(_IconBase["default"], {
        viewBox: icon.viewBox,
        key: icon.id
      }, /*#__PURE__*/_react["default"].createElement("g", null, icon.paths.map(function (p, index) {
        return /*#__PURE__*/_react["default"].createElement("path", {
          key: index,
          d: p
        });
      })))), this.props.getTagLabel(this.props.title)), isCollapsible && /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].icon
      }, this.state.open ? /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null) : /*#__PURE__*/_react["default"].createElement(_arrowLeft["default"], null))), this.state.open && this.props.children);
    }
  }]);
}(_react["default"].Component);
_defineProperty(Component, "propTypes", {
  title: _propTypes["default"].node,
  children: _propTypes["default"].node,
  collapsible: _propTypes["default"].bool,
  displayOptions: _propTypes["default"].object,
  icon: _propTypes["default"].string,
  color: _propTypes["default"].string,
  isCollapsed: _propTypes["default"].bool,
  getTagLabel: _propTypes["default"].func
});